import { render, staticRenderFns } from "./BookmarkButton.vue?vue&type=template&id=5a637abf&scoped=true"
import script from "./BookmarkButton.vue?vue&type=script&lang=js"
export * from "./BookmarkButton.vue?vue&type=script&lang=js"
import style0 from "./BookmarkButton.vue?vue&type=style&index=0&id=5a637abf&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a637abf",
  null
  
)

export default component.exports